import React from 'react';
import ReactGA from 'react-ga4';

let gaInitialized = false;

const withAnalytics = (WrappedComponent = null) => (props) => {
	const GA_MEASUREMENT_ID =
		import.meta.env.VITE_GA_MEASUREMENT_ID || import.meta.env.VITE_GA4_ID || '';

	if (GA_MEASUREMENT_ID && !gaInitialized) {
		ReactGA.initialize(GA_MEASUREMENT_ID);
		gaInitialized = true;
	}

	if (gaInitialized) {
		try {
			ReactGA.send({
				hitType: 'pageview',
				page: window.location.pathname + window.location.search,
			});
		} catch (e) {
			// noop: analytics should never break the app
		}
	}

	return <WrappedComponent {...props} />;
};

export default withAnalytics;
